import SEOHead from "../components/SEOHead";
import Header from "../components/Header";
import Footer from "../components/Footer";
import FloatingCTA from "../components/FloatingCTA";
import CitiesSection from "../components/CitiesSection";
import ContactForm from "../components/ContactForm";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export const ZonesIntervention = () => {
  return (
    <>
      <SEOHead
        title="Zones d'intervention – Serrurier Sénart, Melun et alentours"
        description="Découvrez toutes les villes où intervient Serrurier Lieusaint : Sénart, Melun, Combs-la-Ville, Savigny-le-Temple et plus de 50 communes. Intervention rapide 24h/24."
      />
      <Header />
      <main>
        {/* Hero Section */}
        <section className="py-16 md:py-24 bg-zinc-950">
          <div className="container-custom">
            {/* Breadcrumb */}
            <nav className="flex items-center gap-2 text-sm text-zinc-400 mb-8">
              <Link to="/" className="hover:text-yellow-400 transition-colors">Accueil</Link>
              <ChevronRight className="w-4 h-4" />
              <span className="text-yellow-400">Zones d'intervention</span>
            </nav>

            <div className="max-w-3xl">
              <h1 className="text-4xl md:text-6xl font-bold uppercase tracking-tight text-white mb-6 font-heading" data-testid="zones-title">
                Zones d'intervention
                <span className="block text-yellow-400 text-2xl md:text-4xl mt-2">
                  Plus de 50 villes desservies
                </span>
              </h1>
              <p className="text-lg text-zinc-300">
                Serrurier Lieusaint intervient rapidement dans toute la zone de Sénart, Melun et 
                leurs alentours. Découvrez toutes les villes où nous intervenons 24h/24.
              </p>
            </div>
          </div>
        </section>

        {/* All Cities */}
        <CitiesSection showAll={true} />

        <ContactForm />
      </main>
      <Footer />
      <FloatingCTA />
    </>
  );
};

export default ZonesIntervention;
